import { translations } from '@lmc/rostering/src'

export const enTranslations = {
  ...translations,
  general: {
    buttons: {
      archive: 'Archive',
      cancel: 'Cancel',
      confirm: 'Confirm',
      exportPDF: 'Export to PDF',
      downloadPDF: 'Download PDF',
      next: 'Next',
      restore: 'Restore',
      save: 'Save',
      view: 'View',
      edit: 'Edit',
      back: 'Back',
      clear: 'Clear',
      undo: 'Undo',
      showMore: 'Show more',
      showLess: 'Show less',
      signOut: 'Sign out',
      review: 'Review'
    },
    forms: {
      missingFieldsWarning: 'Please fill in all required fields',
      successfullySaved: 'Update saved',
      internalError:
        'Ooops! Something went wrong. Please contact support if this problem persists.'
    },
    filters: {
      dateRanges: {
        lastWeek: 'Last Week',
        lastMonth: 'Last Month',
        lastThreeMonths: 'Last Three Months',
        lastYear: 'Last Year'
      }
    },
    emptyState: {
      noTeamListResultTitle: 'Shoot... No user to show you',
      noResidentsListResultTitle: 'Shoot... No {{variable}} to show you',
      noTeamListResponseTitle: 'Shoot... No team members to show you',
      noServiceUsersResponseTitle: 'Shoot... No {{variable}} to show you',
      noTeamListResponseDescription:
        'Start inviting team members with the blue button on the top right.',
      noTeamListResultDescription:
        'Please check if you spelled the name correctly',
      noServiceUsersResponseDescription:
        'Start adding {{variable}} with the blue button on the top right.'
    },
    options: {
      peopleOptions: {
        clients: 'Clients',
        customers: 'Customers',
        patients: 'Patients',
        residents: 'Residents',
        supportedPersons: 'Supported Persons',
        serviceUsers: 'Service Users',
        tenants: 'Tenants',
        label: 'How do you refer to the people you support?'
      },
      planOptions: {
        carePlans: 'Care Plans',
        supportPlans: 'Support Plans',
        label: 'Do you have Care Plans or Support Plans?'
      },
      genderOptions: {
        male: 'Male',
        female: 'Female'
      },
      signOptions: {
        now: 'Now',
        later: 'Later'
      }
    },
    team: {
      teamMembers: 'Team Members',
      typeToSearch: 'Type to search....',
      invite: 'Invite',
      inviteTeamMember: 'Invite a Team Member',
      status: 'Status',
      role: 'Role',
      zone: 'Zone',
      noZone: 'You need Pro Plan to activate Zone feature.',
      viewPro: 'View Pro Plan',
      site: 'Site'
    },
    resident: {
      addServiceUser: 'Add a {{variable}}',
      remarks: 'Remarks'
    }
  },
  aboutMe: {
    title: 'About Me',
    titleAbout: 'About',
    description: 'Description',
    writtenBy: 'Supported to write this by',
    history: 'History',
    reviewed: 'Reviewed: ',
    whosAboutMe: '`s About me',
    paywall: {
      title: 'About me',
      subTitle:
        'Keep up to date on the details of your {{preferredPeopleNominative}} with the new extended About me section!'
    },
    sections: {
      importantAboutMe: 'What is important to me',
      importantAboutMeTooltip:
        'A description of what is most important to you. Include any essential information that any professional in health and social care should know about you in any situation, including emergencies but also personal interests and values.',
      importantPeople: 'People who are important to me',
      importantPeopleTooltip:
        'Details of who is important to you and why. They could be family members, carers, friends, members of staff etc. Include how you want the people important to you to be engaged and involved in your care and support in both emergency and normal situations. ',
      communicationPreferences:
        'How I communicate and how to communicate with me',
      communicationPreferencesTooltip:
        'A description of how you communicate normally including any communication aids you use. Include your preferred language of communication and how you would communicate when you are in pain or distress.',
      myWellness: 'My wellness',
      myWellnessTooltip:
        'A description covering what you are able to do, how you engage with others and how you feel on a typical day. Include any cause and/or signs that indicate you might become unwell. Describe how you behave differently on a bad day.',
      doAndDont: "Please do and please don't",
      doAndDontTooltip:
        'A description of things you want someone supporting you to do (or not to do).  For example, talk to me not to my carer, remind me to take my medication, encourage me to wash my hands regularly, explain to me what is happening and why.',
      howAndWhen: 'How and when to support me',
      howAndWhenTooltip:
        'A description of how and when you want someone caring for you to support you. This could include support you need to maintain important routines or to carry out particular activities. Include how you want the support to be provided.',
      worthKnowing: 'Also worth knowing about me',
      worthKnowingTooltip:
        'A description of what is worth knowing about you for people caring or supporting you. This could include a short history of your life, where you have worked, where you lived, important events in your life, important people in your past/current life. '
    }
  },
  components: {
    labelTextBox: {
      readOnly: 'READ ONLY',
      loseText: 'You will lose your text, are you sure?'
    },
    formPrompt: {
      title: 'Are you sure?',
      body: "The changes you've made will be lost."
    },
    confirmationDialog: {
      deleteInstruction: 'To delete permanently, type their name in full.',
      next: 'Next',
      delete: 'Delete'
    },
    logEditForm: {
      viewChart: 'View Chart',
      viewMedication: 'View Medication',
      witnessedBy: 'Witnessed by {{name}}',
      editedBy: 'Edited by {{name}} on {{day}}',
      attachedMedia: 'Attached Media',
      description: 'Description',
      timeLogged: 'Time Logged',
      logRevisions: 'Log Revisions',
      logRestored: 'Log Restored',
      logRemoved: 'This log has been removed',
      locationAvailable: 'Location',
      locationUnavailable: 'Location Unavailable',
      whyCantISeeThis: `Why can't I see this?`,
      linkedGoals: 'Goals'
    },
    approvedDevices: {
      title: 'Approved Devices',
      trustedDevices: 'Trusted Devices',
      lastSeen: 'Last Seen',
      totalSessions: 'Total Sessions',
      nothingToSeeHere: 'Nothing to see here'
    }
  },
  consent: {
    createConsentForms: {
      title: "{{variable}}'s Consent Forms",
      forms: 'View Consent forms',
      emptyState: 'Nothing to see here!',
      youHavent: 'You haven`t added any Consent Forms yet for ',
      sections: {
        lackOfCapacity: 'Lack of capacity statements',
        archived: 'Archived statements'
      },
      components: {
        dropdownBtn: {
          addConsentForm: 'Add consent form',
          addCapacityForm: 'Add capacity form'
        },
        listItem: {
          signed: 'SIGNED',
          refused: 'REFUSED',
          archived: 'ARCHIVED',
          unsigned: 'Unsigned',
          view: 'VIEW',
          edit: 'EDIT',
          archive: 'ARCHIVE'
        },
        modal: {
          warning: 'warning!',
          row1: 'This action will archive the form... ',
          row2: ' Are you sure you want to continue?',
          wasArchived: 'The form has been archived.',
          yourProgress: 'Your progress will be lost.'
        },
        consentModal: {
          selectConsentForms: 'Select Consent Forms',
          selectCapacityForm: 'Select Capacity Form',
          clickHere: 'Click here',
          toViewForms: 'to view consent forms',
          toViewCapacityForms: 'to view capacity forms',
          cantSee: "Can't see what you need?",
          customEntry: 'CUSTOM ENTRY',
          comingSoon: 'Coming soon',
          consentsTo: '’s consent statements',
          readOnly: 'READ ONLY',
          disclaimer: 'Consent to Care Disclaimer',
          statement: '{{variable}}’s Consent Statement',
          signature: 'Signature',
          signNowLaterSection:
            'Would you like to add a Signature Now or Later?',
          thisSignature:
            'This Signature will be attached to this specific form.',
          nextReview: 'Next review',
          threeMonth: '3 months',
          sixMonths: '6 months',
          oneYear: '1 year',
          noFurtherSupport: 'No further support required',
          finishForm: 'Finish form',
          theForm: 'The form has been saved to Name profile',
          whenYou:
            'When you are ready to sign, you can go to their consent library',
          backHome: 'Back to home',
          formsLocation: 'Go to forms location',
          enterSignatures: 'Enters Signature Flow',
          consentsToCare: 'Consents to care',
          signsConsentsToCare: '{{variable}}`s consents',
          consentHistory: 'Consent History',
          confirm:
            'I have read and understand the consent being given on {{variable}}`s behalf',
          sign: 'SIGN',
          consentToCare: 'Consent to Care',
          lastReview: 'Last review',
          noReviewsYet: 'No reviews yet',
          review: 'Review',
          noReviewSet: 'No Review set',
          clickToAddTitle: 'Click to add a Title',
          populateHere: 'Your selections will populate here',
          loseText: 'You will lose your text, are you sure?',
          downloadPDF: 'Download PDF',
          downloadPDFMobile: 'PDF',
          createConsent: 'Click here to select forms',
          viewConsent: 'Click here to view forms',
          linkedCarePlans: 'Linked Care Plans',
          linkedFuturePlans: 'Linked Future Plans',
          attachedToFuturePlan: 'Attached to Future Plan',
          consentFormsWillAppear:
            'Consent forms will appear in these care plans',
          consentFormsWillAppearInFuturePlans:
            'Consent forms will appear in these future plans'
        },
        consentConfirmationCard: {
          question: "Ready to confirm the {{nominative}}'s consent?",
          confirmButton: 'Confirm',
          signButton: 'Sign',
          consentStatusLabel: 'Consent status',
          helperText: 'This will count for all consent forms being signed now',
          options: {
            noStatus: 'No status',
            saveForm: 'Save form',
            signForm: 'Sign form',
            consentNotObtained: 'Consent not obtained',
            completed: 'Completed',
            planned: 'Planned',
            requested: 'Requested',
            scheduled: 'Scheduled',
            postponed: 'Postponed',
            cancelled: 'Cancelled',
            withdrawn: 'Withdrawn',
            refused: 'Refused',
            provided: 'Provided'
          },
          infoText: {
            noStatus:
              'A short description will show here based on your selection',
            consentNotObtained:
              'Informed consent could not be obtained from the individual or their representative. No review needed',
            completed:
              'The individual or their representative has given informed consent and the activity is complete',
            planned: 'The need to get informed consent has been identified.',
            requested:
              'Informed consent has been requested from the individual or their representative, but no response has been received yet',
            scheduled: 'A time has been arranged to request informed consent',
            postponed:
              'The time to request for informed consent has been delayed',
            cancelled:
              'Request for informed consent was cancelled before asking the individual or their representative. No review needed',
            withdrawn:
              'After initially giving informed consent, the individual or their representative has withdrawn it. No review needed',
            refused:
              'The individual or their representative has refused to give informed consent',
            provided:
              'The patient or their representative has given informed consent'
          },
          extra: {
            postponed: {
              label: 'What was the last review date?',
              helper: 'Please enter the last date set for review',
              placeholder: 'DD-MM-YYYY'
            },
            withdrawn: {
              label: 'Give a reason for withdrawal',
              helper: 'This will attached to the consent history',
              placeholder: 'No longer applicable to his situation'
            }
          }
        }
      }
    },
    consentTemplatesLibrary: {
      title: 'Consent Management Templates Library',
      emptyState: 'Nothing to see here!',
      youHavent: 'You haven`t added any Consent Form Template yet for ',
      modal: {
        warning: 'warning!',
        row1: 'This action will archive the template... ',
        row2: ' Are you sure you want to continue?',
        wasArchived: 'The template has been archived.'
      },
      wasRestored: 'The template has been restored.',
      lackOfCapacity: 'CAPACITY FORM',
      updateTemplate: 'The template has been updated.',
      archived: 'ARCHIVED',
      serviceUsers: 'service users'
    }
  },
  skillsAndNeeds: {
    templateTitle: 'Needs and Skills',
    needTemplatesTitle: 'Need templates',
    residentNeedsSubtitle:
      'Assign needs for {{firstName}} and reuse them in their profile and {{carePlans}}.',
    needTemplatesSubtitle:
      'Create {{serviceUsers}} need templates at this site and reuse them in profiles and {{carePlans}}.',
    addNewNeed: 'Add need',
    emptyNeedsHeading: 'Nothing to see here...',
    emptyNeedsText: 'Add a need to start building your template!',
    needsCount: '{{current}} out of {{total}} need templates',
    residentNeedsCount: '{{current}} out of {{total}} needs',
    addedDateColumn: 'Added date',
    notesColumn: 'Notes',
    notesNA: 'N/A',
    sortBy: 'Sort by',
    sortNewestFirst: 'Added date (newest to oldest)',
    sortOldestFirst: 'Added date (oldest to newest)',
    sortNameAZ: 'Need name (A to Z)',
    sortNameZA: 'Need name (Z to A)',
    needColumn: 'Need',
    needsCategoryColumn: 'Needs category',
    actionsColumn: 'Actions',
    editNeed: 'Edit',
    deleteNeedAction: 'Delete need',
    addNeedModalTitle: 'Adding new need',
    addNeedConfirm: 'Add',
    needAdded: 'Need assigned!',
    needAddFailed: 'Failed to add need. Please try again.',
    editNeedModalTitle: 'Editing need',
    saveChanges: 'Save changes',
    changesSaved: 'Changes saved!',
    needUpdateFailed: 'Failed to save changes. Please try again.',
    deleteNeedModalTitle: 'Deleting need',
    deleteNeedConfirm: 'Delete',
    deleteNeedBody: 'Are you sure you want to delete this need?',
    deleteNeedWarning:
      'Deleting this need will remove it from all associated records, including:',
    deleteNeedProfilesItem: '{{serviceUsers}} profiles and support plans',
    needDeleted: 'Need deleted!',
    needDeleteFailed: 'Failed to delete need. Please try again.',
    unassignNeedModalTitle: 'Deleting need',
    unassignNeedConfirm: 'Delete',
    unassignNeedBody: 'Are you sure you want to delete this need?',
    unassignNeedWarning:
      'Deleting this need will remove it from all associated records, including their {{carePlansNominative}}.',
    deleteSkillModalTitle: 'Deleting skill',
    skillTemplatesTitle: 'Skill templates',
    skillTemplatesSubtitle:
      'Create staff skill templates at this site and reuse them when assigning carers to {{serviceUsers}}.',
    skillsCount: '{{current}} out of {{total}} skill templates',
    sortSkillNameAZ: 'Skill name (A to Z)',
    sortSkillNameZA: 'Skill name (Z to A)',
    skillMatrix: 'Training and skills matrix',
    addNewSkill: 'Add skill',
    addSkillModalTitle: 'Adding new skill',
    assignNeed: 'Assign a need',
    editAssignNeed: 'Editing need',
    editAssignSkill: 'Edit assigned skill',
    editSkill: 'Edit skill',
    editSkillModalTitle: 'Editing skill',
    assignNewSkill: 'Assign a new skill',
    nothingToSee: 'Nothing to see here...',
    addSkill: 'Add a skill to start building your template!',
    addNeedsToProfile: 'Add needs to this profile',
    assignNeedEmptyState: 'Assign a need to this profile.',
    assignNeedEmptyStateLink: 'Learn how to assign',
    addSkillsToProfile: 'Add skills to this profile',
    findOutMore: 'Find out more',
    deleteSkill: 'Remove skill',
    deleteSkillAction: 'Delete skill',
    deleteNeed: 'Remove need',
    assignSkill: 'Assign a new skill',
    assignNewNeed: 'Assigning need',
    areYouSure: 'Are you sure you want to delete?',
    areYouSureNeed: 'Are you sure you want to remove need?',
    areYouSureSkill: 'Are you sure you want to remove skill?',
    byRemovingNeed:
      'By removing the need, it will be removed from the {{variable}} profile',
    byRemovingSkill:
      'By removing the skill, it will be removed from the {{variable}} profile',
    yesDelete: 'Yes, delete',
    yesRemove: 'Yes, remove',
    byDeleting: 'Are you sure you want to delete this skill?',
    needsRemoved:
      'The needs will be removed from {{carersProfileVariable}} profiles and {{carePlansVariable}}',
    skillsRemoved:
      'Deleting this skill will remove it from all associated records, including:',
    deleteSkillProfilesItem: 'Team member profiles',
    tableReadOnly: 'Your site is part of a group: ',
    tableReadOnlyDescription:
      'The template is only editable by a Group Admin, through the group dashboard.',
    tableReadOnlyLink: ' Find out more here',
    toAddSkill: 'To add skills, switch to the Groups view',
    trainingCompleted: 'Training completed',
    backToProfile: 'Back to Profile',
    viewDetails: 'View details',
    needs: 'Needs',
    skills: 'Skills',
    skillsAndTrainings: 'Training and skills',
    assignNewNeedButton: 'Assign need',
    assignNewSkillButton: 'Assign new skill',
    selectNeeds: 'Select Needs',
    selectedNeeds: 'Selected Needs',
    chooseFormList: 'Choose from list',
    cannotDeleteSkillBold:
      'Mandatory skills cannot be removed from a team member’s profile.',
    cannotDeleteSkill:
      ' Go to ‘Skills and Needs’ in preferences to edit this skill',
    cannotDeleteNeed: ' To remove this need I must review the {{variable}}',
    addViaTemplate: 'Needs and skills template',
    skillsNotAddedYet: 'No skills added yet',
    skillsNotAddedToTheTemplate:
      ' No skills added to the template. To add new skills, go to ',
    needsNotAddedToTheTemplate:
      ' No needs added to the template. To add new needs, go to ',
    skillsContactGroupAdmin:
      'No skills added to the template. To add skills, please contact your group admin.',
    needsContactGroupAdmin:
      'No Needs added to the template. To add needs, please contact your group admin.',
    skillsContactCarehomeAdmin:
      'No skills added to the template. To add skills, please contact your admin.',
    needsContactCarehomeAdmin:
      'No needs added to the template. To add needs, please contact your admin.',
    needsNotAddedYet: 'No needs added yet!',
    dueAndOverdueTraining: 'Due and overdue training',
    skillsAndNeedsCapacity: 'Skills and Needs Capacity',
    capacityPopover:
      'This table shows the ratio of recorded needs to staff with the right skills to meet those needs.',
    byTeamMember: 'By team member',
    byTraining: 'By training',
    skillsAneNeedsCapacity: 'Skills and Needs Capacity',
    dots: {
      valid: 'Valid',
      dueSoon: 'Due soon',
      notValid: 'Overdue',
      notAssigned: 'Not assigned',
      trainingNotRequired: 'Training not required',
      trainingOverdue: 'Training overdue',
      achievedDateNotSet: 'Achieved date not set',
      trainingDueSoon: 'Training due soon',
      trainingValid: 'Training valid',
      skillNotAssigned: 'Skill not assigned',
      noExpire: 'Does not expire'
    },
    table: {
      skillMatrix: 'Training and skills matrix',
      exportTable: 'Export table',
      skills: 'Skills',
      skill: 'Skill',
      needs: 'Needs',
      training: 'Training',
      validity: 'Validity',
      coveredNeeds: 'Covered needs',
      category: 'Category',
      selectCategoriesToFilter: 'Select categories to filter',
      lastRefreshed: 'Last refreshed',
      dueForRefresh: 'Due for refresh',
      mandatory: 'Mandatory',
      achieved: 'Achieved / Refreshed',
      refreshDue: 'Refresh Due',
      yes: 'Yes',
      no: 'No',
      dueSoon: 'DUE SOON',
      overDue: 'OVERDUE',
      noSet: 'NO SET',
      teamMember: 'Team member',
      reviewalDate: 'Reviewal date',
      carersWithValidSkills: 'Carers with valid skills',
      residentsWithNeeds: 'Residents with needs'
    },
    form: {
      skillName: 'Skill',
      trainingName: 'Training name',
      trainingCompleted: 'Training completed',
      skillNameRequired: 'Skill name is a required field',
      skillAlreadyAdded:
        'The chosen skill has already been added. Choose a different one.',
      needRequired: 'Need is a required field',
      needAlreadyAssigned: 'This need is already assigned to this person.',
      trainingNameIsRequired: 'Enter the training name.',
      validForRequired: 'Enter the number of months the training is valid for.',
      trainingNameRequired:
        'Equality, Diversity and Human Rights - Online - ALL',
      trainingRequired: 'Training required',
      months: 'months',
      validForMonths: 'Valid for {{count}} months',
      trainingExpires: 'Training expires',
      trainingValidFor: 'Training valid for',
      coveredNeeds: 'Covered needs',
      category: 'Category',
      startTyping: 'Choose a category',
      selectFromList: 'Choose a skill',
      coveredNeedsPlaceholder: 'Choose covered needs',
      needNamePlaceholder: 'Choose a need',
      needCategoryPlaceholder: 'Choose a category',
      selectSkill: 'Select skill',
      selectNeed: 'Need',
      selectNeedPlaceholder: 'Choose a need',
      selectNeedTooltip:
        'Choose a need template from this site to assign to this person.',
      noNeedTemplatesTitle: 'No templates yet.',
      noNeedTemplatesSubtitle: 'Ask an admin to create them for this site.',
      noNeedTemplatesLink: 'Create need templates',
      notes: 'Notes',
      skillNameTooltip: 'Choose an existing skill or type to create a new one.',
      categoryTooltip:
        'The category you select or create by typing it, will create filters you can use in the skills matrix. Note: You can only choose one category.',
      categoryHelperText1:
        'Choose a category to be used to filter skills in areas like ',
      categoryHelperText2: '. Or create a new category by typing one in.',
      categoryHelperLink: 'Training and Skills Matrix',
      coveredNeedsTooltip: 'Choose all needs that this skill covers.',
      needName: 'Need',
      needNameRequired: 'Choose a need, or create a custom one.',
      needNameTooltip: 'Choose an existing need or type to create a new one.',
      needDuplicate:
        'The chosen need has already been added. Choose a different one.',
      needCategoryLabel: 'Needs category',
      needCategoryRequired: 'Choose a category for this need.',
      needCategoryTooltip:
        'Choose a category to group related needs, making them easier to organise and transfer between systems.',
      needAlreadyUsed:
        'The chosen need is already used in a skill template. Each covered need can only be matched to one skill.'
    },
    skillAdded: 'Skill added!',
    skillUpdated: 'Changes saved!',
    skillDeleted: 'Skill deleted!',
    skillDeleteFailed: 'Failed to delete skill. Please try again.',
    skillAddFailed: 'Failed to add skill. Please try again.',
    skillUpdateFailed: 'Failed to save changes. Please try again.'
  },
  dummy: {
    addClient: {
      setStatus: 'Set a status'
    }
  },
  homeDashboard: {
    portals: {
      title: "What's next",
      description: 'Help us create our product roadmap',
      button: 'Share your feeback'
    },
    advert: {
      title: "What's on offer",
      subtitle: 'Request a feature?'
    },
    memberBenefits: {
      title: 'Perks',
      featureRequest: 'Request a feature'
    }
  },
  onboarding: {
    buttons: {
      getStarted: 'Let’s get started',
      skipTutorial: 'Skip tutorial',
      setupApp: 'Set up the app',
      skipStep: 'Skip this step'
    },
    inputs: {
      name: 'Name',
      dateOfBirth: 'Date of birth',
      gender: 'Gender',
      firstName: 'First name',
      lastName: 'Last name',
      surName: 'Surname',
      email: 'Email',
      userName: 'Username',
      pin: 'PIN',
      selectDate: 'Select Date',
      radioGroupError: 'Please select an option!',
      firstNameError: 'First name is required!',
      lastNameError: 'Last name is required!',
      datePickerError: 'Please enter a date!',
      emailError: 'Email is required!'
    },
    welcome: {
      title: 'Welcome to Log my Care',
      subTitle: 'Log my Care comes in two parts:',
      iconHeader1: {
        title: 'You’re in the Care Office now. From here you can:',
        subTitle: 'CARE OFFICE'
      },
      iconHeader2: {
        title: 'The second part is our mobile app for your care team to:',
        subTitle: 'CARER APP'
      },
      iconBlurb: {
        manageYourResidents: 'Manage your residents',
        onboardYourTeam: 'Onboard your team',
        getOverview: 'Get an overview of care delivered',
        accessPrint: 'Access and print care records',
        recordCare: 'Record care delivery',
        accessCare: 'Access care records'
      },
      setupList: {
        setUpPreferences: 'Set your preferences',
        addResident: 'Add a resident',
        inviteTeam: 'Invite your team',
        activateApp: 'Activate the carer app',
        setupTitle: 'Now let’s help you get set up'
      }
    },
    preferences: {
      title: 'Set your preferred terms',
      subTitle:
        'By changing a term, it will change everywhere in the Care Office and App where it is mentioned.'
    },
    addYourFirst: {
      title: 'Add your first ',
      titleResident: 'Resident',
      add: 'Add ',
      subTitle:
        'Let’s get a first person added so you can see how it all works. You don’t need to add everyone now, you can come back to this later',
      note: 'Note: ',
      noteDescription:
        'You can always access the Residents section of the Care Office to add new residents or update current ones'
    },
    inviteYour: {
      title: 'Invite your team ',
      addTeamMember: 'Add a team member',
      subTitle:
        'Give the senior members of your team access to your account so they can get a view of the care being delivered. Once you’ve added them, each team member will receive a link to help them get started.',
      note: 'Note: ',
      noteDescription:
        'in the Team section of the Care office you will be able to add and edit additional details for each carer'
    },
    activate: {
      title: 'Activate the Carer App',
      titleDownload: 'Download the Carer App',
      description1: 'The mobile app is used to',
      description2: ' manage the daily care operations. ',
      description3:
        'As the administrator, you might not be involved in delivering daily care, but we recommend you',
      description4: ' install and test the mobile app ',
      description5: ' in order to get a view of how everything works.',
      chooseYour: 'Choose your pin',
      numericPin:
        'This is the numeric pin you will have to use to login in the mobile app'
    },
    qrCode: {
      scan: 'Scan this QR code',
      or: 'OR',
      checkEmail: 'Check your email'
    },
    complete: {
      title: 'Book a complimentary onboarding call',
      description1: 'Need someone to show you the ropes? Feel free to',
      description2: 'book a free 1-2-1 onboarding session',
      description3: 'with our team and they’ll help you get started.',
      getInTouch: '(we’ll get in touch via email)',
      session: 'I’d like to book my 1-2-1 session',
      letsGo: 'Let’s go!',
      team: 'Our team is here to help',
      complete: 'Complete!'
    },
    steps: {
      preferences: 'Set preferences',
      team: 'Invite your team',
      residentAdd: 'Add a ',
      resident: 'Resident',
      activate: 'Activate the App'
    }
  },
  reports: {
    occupancyReport: {
      title: 'Occupancy',
      founding: 'Founding',
      foundingSub: 'Your current active service users shown by type of funding',
      currentOccupancy: 'Current occupancy',
      currentOccupancySub:
        'Your current bed occupancy based on the number of active service users',
      overtime: 'Change Over Time',
      overtimeSub: 'Percentage of beds occupied displayed over time'
    },
    careDelivery: {
      title: 'Care Delivery',
      allCategoriesFilter: 'All Categories'
    },
    cqi: {
      title: 'Care Quality Indicators',
      table: {
        indicator: '{{variable}} Indicator'
      },
      safe: {
        title: 'Safe',
        dailyActiveCarers: {
          indicator: 'Average daily active carers',
          timeframe: '1 month'
        },
        incidentsRecorded: {
          indicator: 'Incidents recorded',
          timeframe: '6 months'
        },
        missedTodos: { indicator: "To-Do's missed", timeframe: '1 month' }
      },
      effective: {
        title: 'Effective',
        carePlansSigned: {
          indicator: 'Signed {{carePlansNominative}}',
          timeframe: '6 months'
        }
      },
      responsive: {
        title: 'Responsive',
        carePlansComplete: {
          indicator: '{{carePlansNominative}} completed',
          timeframe: 'Present time'
        },
        carePlansInDate: {
          indicator: '{{carePlansNominative}} in date',
          timeframe: 'Present time'
        },
        eolCarePlans: {
          indicator:
            '{{preferredPeopleNominative}} with EOL {{carePlansNominative}}',
          timeframe: 'Present time'
        }
      },
      caring: {
        title: 'Caring',
        aboutSections: {
          indicator: '{{preferredPeopleNominative}} ‘Notes’ sections completed',
          timeframe: 'Present time'
        },
        personalDetails: {
          indicator:
            '{{preferredPeopleNominative}} ‘Personal details’ completed',
          timeframe: 'Present time'
        },
        profilePictures: {
          indicator: '{{preferredPeopleNominative}} with profile pictures',
          timeframe: 'Present time'
        }
      },
      'well-led': {
        title: 'Well-led',
        carePlansOnTime: {
          indicator: '{{carePlansNominative}} reviewed on time',
          timeframe: '6 months'
        },
        carePlansReviewed: {
          indicator: '{{carePlansNominative}} reviewed',
          timeframe: '6 months'
        },
        carerProfilePictures: {
          indicator: 'Staff with profile pictures',
          timeframe: 'Present time'
        }
      }
    }
  }
}
